"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryCodeFromSwiftBic = exports.getCountryCodeFromIban = void 0;
/**
 * Slice the iban to retrieve the country code
 * @param {string} iban The iban
 * @returns {string} - The country code
 */
const getCountryCodeFromIban = (iban) => {
    return iban.slice(0, 2);
};
exports.getCountryCodeFromIban = getCountryCodeFromIban;
/**
 * Slice the bic to retrieve the country code
 * @param {string} bic - The bic
 * @returns {string} - The country code
 */
const getCountryCodeFromSwiftBic = (bic) => {
    return bic.slice(4, 6);
};
exports.getCountryCodeFromSwiftBic = getCountryCodeFromSwiftBic;
